// extracted by mini-css-extract-plugin
module.exports = {"contact-form":"ContactForm_contact-form__kIQPi","submit-wrapper":"ContactForm_submit-wrapper__RAxfx"};